import api from './api';

export const integrationKeyService = {
  list:     (facilityId) => api.get('/bridge/keys', { params: facilityId ? { facilityId } : {} }),
  generate: (payload)    => api.post('/bridge/keys', payload),
  revoke:   (id)         => api.delete(`/bridge/keys/${id}`),
};
